import axios from 'axios'
const _axios = axios.create()

_axios.interceptors.request.use((config) => {
  const token = localStorage.token
  if (token === '' || token === undefined || token === null) {
    return config
  } else {
    config.headers.Authorization = 'Bearer ' + (token || '')
    return config
  }
})
_axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      console.warn(error)
      error.response.shouldRedirectToLogin = true
      window.location.hash = '/login'
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message)
  }
  return Promise.reject(error)
})

export default _axios



// WEBPACK FOOTER //
// ./src/utils/axiosWrapper.js